import React, { FC, Fragment } from 'react';
import { Box, Divider, Typography, Unstable_Grid2 as Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { PaddedPaper } from 'components';
import * as paths from 'paths';

import {
  Description,
  Duration,
  EnableSwitch,
  FormActions,
  Scorings,
  Segments,
  Title,
} from './index';
import { useLocation } from 'react-router-dom';

const LeaderboardsForm: FC = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  function renderTitleText() {
    if (pathname === paths.adminLeaderboardsCreate) {
      return t('admin:leaderboardCreate');
    }

    return t('admin:leaderboardEdit');
  }

  return (
    <Fragment>
      <PaddedPaper padding={24}>
        <Grid container spacing={4} alignItems="center" justifyContent="space-between">
          <Grid>
            <Typography variant="h4">{renderTitleText()}</Typography>
          </Grid>

          <Grid>
            <EnableSwitch />
          </Grid>
        </Grid>

        <Box marginTop={3}>
          <Title />
        </Box>

        <Box marginTop={7} marginBottom={4}>
          <Divider />
        </Box>

        <Box marginBottom={8}>
          <Segments />
        </Box>

        <Box marginBottom={8}>
          <Duration />
        </Box>

        <Box marginBottom={8}>
          <Description />
        </Box>

        <Box>
          <Scorings />
        </Box>
      </PaddedPaper>

      <Box marginTop={3}>
        <FormActions />
      </Box>
    </Fragment>
  );
};

export default LeaderboardsForm;
